import { IMapInputHandler } from 'app/map/services/map_input_handling/MapInputHandler';
import { Cesium } from 'app/cesium';
import { CESIUM_INPUT_EVENT_MAP } from 'app/map/services/map_input_handling/MapInputHandlerService';
import $ from 'jquery';

const { SHIFT, CTRL, ALT } = Cesium.KeyboardEventModifier;

function setRightPaneBorder(enable: boolean): void {
    $('#main-right-pane').css({
        border: enable ? '2px dashed' : 'none',
    });
}

export class CesiumMapInputHandler {
    private _mapInputHandler: IMapInputHandler;
    private _cesiumEventHandler: Cesium.ScreenSpaceEventHandler;

    constructor(mapInputHandler: IMapInputHandler) {
        this._cesiumEventHandler = undefined;
        this._mapInputHandler = mapInputHandler;
    }

    public create(viewer: Cesium.Viewer): void {
        this._cesiumEventHandler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);

        Object.keys(CESIUM_INPUT_EVENT_MAP).forEach((method) => {
            const type = CESIUM_INPUT_EVENT_MAP[method];
            if (this._mapInputHandler[method]) {
                const func = this._mapInputHandler[method].bind(this._mapInputHandler);
                this._cesiumEventHandler.setInputAction((e) => func(e), type);
                this._cesiumEventHandler.setInputAction((e) => func(e), type, CTRL);
                this._cesiumEventHandler.setInputAction((e) => func(e), type, SHIFT);
            }
        });

        if (!this._mapInputHandler.isDefault) {
            setRightPaneBorder(true);
        }
    }

    public destroy(): void {
        if (this._cesiumEventHandler && !this._cesiumEventHandler.isDestroyed()) {
            this._cesiumEventHandler.destroy();
        }
        setRightPaneBorder(false);
    }

    public get eventHandler(): Cesium.ScreenSpaceEventHandler {
        return this._cesiumEventHandler;
    }
}
